import { TYPES } from './actions';
import entity from './entity';

import { merge } from '../../../../utils/state';
import ReduxRestEntity from '../../../../utils/reduxRestEntity';

const coreReducer = entity.getReducer();

const INITIAL_STATE = {
  creditCards: ReduxRestEntity.initialState,
  cardSubOrganizations: ReduxRestEntity.initialState,
  declinedTransactions: ReduxRestEntity.initialState,
};

const reducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case TYPES.GET_CREDIT_CARD_LIST_REQUEST:
      if (action.payload.page === 1) {
        return {
          ...state,
          creditCards: {
            ...INITIAL_STATE.creditCards,
            isLoading: true,
          },
        };
      }
      return merge(state, {
        creditCards: merge(state.creditCards, {
          error: null,
          isLoading: true,
        }),
      });
    case TYPES.GET_CREDIT_CARD_LIST_SUCCESS:
      return merge(state, {
        creditCards: merge(state.creditCards, {
          data: merge(state.data, action.payload),
          error: null,
          isLoading: false,
        }),
      });
    case TYPES.GET_CREDIT_CARD_LIST_FAILURE:
      return merge(state, {
        cardSubOrganizations: merge(state.cardSubOrganizations, {
          error: action.payload,
          isLoading: false,
        }),
      });
    case TYPES.GET_CARD_SUB_ORGANIZATIONS_REQUEST:
      if (action.payload.page === 1) {
        return {
          ...state,
          cardSubOrganizations: {
            ...INITIAL_STATE.cardSubOrganizations,
            isLoading: true,
          },
        };
      }
      return merge(state, {
        cardSubOrganizations: merge(state.cardSubOrganizations, {
          error: null,
          isLoading: true,
        }),
      });
    case TYPES.GET_CARD_SUB_ORGANIZATIONS_SUCCESS:
      return merge(state, {
        cardSubOrganizations: merge(state.cardSubOrganizations, {
          data: merge(state.data, action.payload),
          error: null,
          isLoading: false,
        }),
      });
    case TYPES.GET_CARD_SUB_ORGANIZATIONS_FAILURE:
      return merge(state, {
        cardSubOrganizations: merge(state.cardSubOrganizations, {
          error: action.payload,
          isLoading: false,
        }),
      });
    case TYPES.CLEAR_CARDS_LIST:
      return INITIAL_STATE;
    case TYPES.GET_DECLINED_TRANSACTIONS_REQUEST:
      return {
        ...state,
        declinedTransactions: {
          data: {},
          isLoading: true,
        },
      };
    case TYPES.GET_DECLINED_TRANSACTIONS_SUCCESS:
      return merge(state, {
        declinedTransactions: merge(state.declinedTransactions, {
          data: action.payload,
          error: null,
          isLoading: false,
        }),
      });
    case TYPES.GET_DECLINED_TRANSACTIONS_FAILURE:
      return merge(state, {
        declinedTransactions: merge(state.declinedTransactions, {
          error: action.payload,
          isLoading: false,
        }),
      });

    default:
      return coreReducer(state, action);
  }
};

export default reducer;
